import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { tokens } from '../styles/tokens.js'

/** Eine abgeleitete Kennzahl: Label, Wert, Einheit. Rein darstellend. */
@customElement('kil-metric')
export class KilMetric extends LitElement {
  static override styles = [
    tokens,
    css`
      :host {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
      }

      dt {
        margin: 0;
        font-size: 0.6875rem;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--kil-ink-dim);
      }

      dd {
        margin: 0;
        font-family: var(--kil-font-mono);
        font-variant-numeric: tabular-nums;
        font-size: 1.0625rem;
        letter-spacing: -0.02em;
      }

      .unit {
        font-size: 0.75em;
        color: var(--kil-ink-dim);
        margin-inline-start: 0.15em;
      }
    `,
  ]

  @property() label = ''
  @property() value = ''
  @property() unit = ''

  override render() {
    return html`
      <dt>${this.label}</dt>
      <dd>${this.value}<span class="unit">${this.unit}</span></dd>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kil-metric': KilMetric
  }
}
